import { isMobileApp } from 'webui/utils/version';
import { PaymentMethod } from 'console/billing/types';
export const openTopupDialog = (options = {}) => ({ type: 'OPEN_TOPUP_DIALOG', ...options });
export const closeTopUpDialog = () => ({
    type: 'CLOSE_TOPUP_DIALOG',
});
export const requestTopup = (options) => async (dispatch, getState, { api }) => {
    const { payment_method, amount_x100, org_inn, org_title, org_address, pay_intent, } = options;
    dispatch({ type: 'REQUEST_TOPUP__REQUEST' });
    if (payment_method != PaymentMethod.yakassa &&
        payment_method != PaymentMethod.auto_invoice)
        throw 'unexpected payment_method';
    try {
        if (payment_method == PaymentMethod.yakassa) {
            let popup = null;
            if (!isMobileApp()) {
                popup = window.open('', '', 'popup, modal=yes, toolbar=no, location=no');
                if (!popup) {
                    alert('не удалось открыть всплывающее окно');
                    console.error("can't open popup for yakassa");
                    return;
                }
            }
            const response = await api.top_up_yakassa({
                amount_x100: typeof amount_x100 === 'string'
                    ? parseInt(amount_x100)
                    : amount_x100,
                pay_intent,
            });
            if (response.payment_url) {
                dispatch({ type: 'PAY__REQUEST' });
                if (isMobileApp()) {
                    window.open(response.payment_url, '_system');
                }
                else {
                    if (popup) {
                        popup.location = response.payment_url;
                        popup.focus();
                        setTimeout(() => popup?.focus(), 100);
                    }
                }
                dispatch({
                    type: 'REQUEST_TOPUP__OK',
                    data: { type: 'redirecting' },
                });
            }
            else {
                popup?.close();
            }
        }
        else if (payment_method == PaymentMethod.auto_invoice) {
            const response = await api.top_up_auto_invoice({
                amount_x100: typeof amount_x100 === 'string'
                    ? parseInt(amount_x100)
                    : amount_x100,
                org_inn: org_inn ?? '',
                org_title: org_title ?? '',
                org_address: org_address ?? '',
                pay_intent,
            });
            if (response.org_details != null) {
                dispatch({
                    type: 'UPDATE_ORG_DETAILS',
                    org_details: response.org_details,
                });
            }
            dispatch({
                type: 'REQUEST_TOPUP__OK',
                data: {
                    type: PaymentMethod.auto_invoice,
                    invoice_pdf: response.invoice_pdf,
                    invoice_filename: response.invoice_filename,
                },
            });
        }
        dispatch({
            type: 'BILLING_SETTINGS__OK',
            data: {
                paid: true,
                last_payment_method: payment_method,
            },
        });
        dispatch(closeTopUpDialog);
    }
    catch (error) {
        dispatch({ type: 'REQUEST_TOPUP__FAIL', error });
    }
};
